import { userStore } from "entities/User/store/userStore";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAvailableModules } from "shared/api/hooks/useAvailableModules";
import { ROLES } from "shared/config";
import { Loader } from "shared/ui";

const RequireModuleAuthorization = ({ module, isLocalAdminModule = false }) => {
  const { data: modules } = useAvailableModules();
  const user = userStore((state) => state.user);
  const location = useLocation();

  if (!user?.roles || !modules)
    return (
      <Loader
        variant="primary"
        size="md"
        className="position-absolute top-50 vw-100 justify-content-center"
      >
        Loading...
      </Loader>
    );

  // ! This is a temporary fix for Accounts Payable
  // TODO implement avaialble modules for Accounts Payable role
  const isAccountsPayable = user?.roles?.data.some(
    (role) => role.name === ROLES.ACCOUNTS_PAYABLE
  );

  const moduleIsAvailable = isLocalAdminModule
    ? modules?.local_admin_modules?.[module]?.available
    : modules.user_modules[module].available;

  return moduleIsAvailable || isAccountsPayable ? (
    <Outlet />
  ) : (
    <Navigate to="/unauthorized" state={{ from: location }} replace />
  );
};

export default RequireModuleAuthorization;
